
export default {
    data(){
        return {
            iconPcr : `dna`,
            iconFileDocument : `file-document`,
            iconPlus : `plus`,
            iconImage :`file-image`,
            iconDx :  `table-large`,
            iconInfoRequest : `information-outline`
        }
    }
}